import { useState } from "react";

import ButtonV2 from "@/components/shared/buttonV2";
import Modal from "@/components/shared/modal";
import ButtonLink from "@/components/shared/buttonLink";

import styles from "./index.module.scss";

type Props = {
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
};

/* アップロード開始から10秒経過した場合 */
const LoadingTipsModal: React.FC<Props> = ({ showModal, setShowModal }) => {
  const [toggle, setToggle] = useState(false);

  const handleLocalStrage = () => {
    if (toggle) {
      localStorage.removeItem("photoUploadTimeIsSlowModalHidden");
      setToggle(false);
      return;
    }
    localStorage.setItem("photoUploadTimeIsSlowModalHidden", "hide");
    setToggle(true);
  };

  return (
    <Modal
      show={showModal}
      showClose={true}
      title="写真のアップロード時間について"
      titleRed={true}
      setShow={setShowModal}
    >
      <div className="m-24">
        <div className="text-[1.6rem]">
          アップロード開始から10秒経過しました。
          <br />
          写真のアップが遅いと感じる場合は以下をご確認ください。
          <br />
        </div>
        <div className={styles.checkbox_wrapper}>
          <input
            className={styles.checkbox_input}
            type="checkbox"
            id="photoUploadTimeIsSlowModalHidden"
            checked={toggle}
            onChange={handleLocalStrage}
          />
          <label
            htmlFor="photoUploadTimeIsSlowModalHidden"
            className={styles.checkbox_label}
          >
            次回から表示しない
            <br />
            (後でサポートページから確認する)
          </label>
        </div>
        <div className="mb-8">
          <ButtonLink
            href="https://cosoji-crew.zendesk.com/hc/ja/articles/12071625566233-%E5%86%99%E7%9C%9F%E3%81%AE%E3%82%A2%E3%83%83%E3%83%97%E3%83%AD%E3%83%BC%E3%83%89%E3%81%8C%E9%81%85%E3%81%84%E3%81%A8%E6%84%9F%E3%81%98%E3%81%9F%E3%82%89"
            width="100%"
            target="_blank"
            btnColor="pink"
            rel="noopener noreferrer"
          >
            写真のアップロードが遅いと感じたら
          </ButtonLink>
        </div>
        <ButtonV2
          variant="primaryOutline"
          layout="fullWidth"
          click={() => setShowModal(false)}
        >
          閉じる
        </ButtonV2>
      </div>
    </Modal>
  );
};

export default LoadingTipsModal;
